const labels = () => ({
	default: "en",
	icon: {
		arrowleft: "←",
		arrowright: "→",
		attach: "📄",
		back: "◀︎",
		cancel: "↖︎",
		close: "✕",
		create: "✚",
		delete: "✕",
		edit: "📝",
		down: "▼",
		"down-alt": "▽",
		forward: "▶︎",
		injection: "🩼",
		lock: "🔓",
		network: "⇄",
		ok: "✔︎",
		pause: "||",
		reload: "↺",
		stop: "◼︎",
		trash: "🗑️",
		up: "▲",
		"up-alt": "△",
		users: "\uD83D\uDC65",
		wheel: "⚙️"
	},
	it : {
		"Actions":"Azioni",
		"Add":"Aggiungi",
		"Aggregation":"Aggregazione",
		"Authentication error":"Errore di autenticazione",
		"Available libraries":"Librerie presenti",
		"Avg":"Medio",
		"AvgF":"Media",
		"Cancel" : "Annulla",
		"Close":"Chiudi",
		"Code":"Codice",
		"ConfirmLibraryReplacement":"Confermi di voler sostituire l'intero contenuto di questa libreria?",
		"Cost":"Costo",
		"Coverage":"Copertura",
		"Coverage type":"Tipo copertura",
		"Create":"Crea",
		"Default language": "Lingua di default",
		"Delete":"Elimina",
		"Delete library":"Elmina libreria",
		"Description":"Nome lungo",
		"Difficulty":"Difficoltà",
		"Duplicate":"Duplica",
		"Duplicate library":"Duplica libreria",
		"Edit":"Modifica",
		"Edit library" : "Modifica libreria",
		"Edit node": "Modifica nodo",
		"Edit question":" Modifica domanda",
		"False":"Falso",
		"High":"Elevato",
		"HighF":"Elevata",
		"Inherit":"Eredita",
		"Languages" : "Lingue",
		"Libraries list":"Elenco librerie",
		"Low":"Basso",
		"LowF":"Bassa",
		"Maturity":"Maturità",
		"Maturity type":"Tipo maturità",
		"Name":"Nome",
		"New control":"Nuovo controllo",
		"New group":"Nuovo nodo",
		"New leaf":"Nuova domanda",
		"New library":"Nuova libreria",
		"New question":"Nuova domanda",
		"NoItemsFound": "Nessun elemento trovato",
		"Note":"Nota",
		"Notes":"Note",
		"Private notes":"Note private",
		"Published":"Pubblicato",
		"Remove":"Elimina",
		"RemoveLastWarning":"ULTIMO AVVISO\n\nConfermi la cancellazione di {{item|questo elemento}}?\n\nQuesta operazione è irreversibile.",
		"RemoveWarning":"ATTENZIONE\n\nConfermi la cancellazione di {{item|questo elemento}}?",
		"Revert":"Ripristina",
		"Save":"Salva",
		"System login": "Accesso al sistema",
		"Select":"Scegli",
		"SelectMulti":"Scegli…",
		"Tags":"Etichette",
		"Unknown":"Ignoto",
		"UnknownF":"Ignota",
		"Unique ID":"ID univoco",
		"Unpublished":"Non pubblicato",
		"Upload library":"Carica libreria",
		"UploadLibraryDefinition":"Carica un file di definizione delle librerie scaricato in precedenza",
		"UploadLibraryDefinitionNotExport":"Carica un file di definizione delle librerie, questo è un export!",
		"Username":" Nome utente",
		"True":"Vero",
		"Version":"Versione",
		"ViewcodePlaceholder":"Lasciare vuoto per mostrare il codice originale",
		"Visible code":"Codice mostrato",
		"Weight":"Peso",
		"Yes":"Sì"
	},
	en: {
		"AvgF":"Avg",
		"ConfirmLibraryReplacement":"Are you sure that you want to replace the entire content of this library?",
		"Description":"Long name",
		"HighF":"High",
		"LowF":"Low",
		"New group":"New node",
		"New leaf":"New question",
		"NoItemsFound": "There are no items yet",
		"RemoveLastWarning":"LAST WARNING\n\nAre you sure you want to remove {{item|this item}}?\n\nThis operation cannot be reverted.",
		"RemoveWarning":"WARNING\n\nAre you sure you want to remove {{item|this item}}?",
		"SelectMulti": "Select…",
		"UnknownF":"Unknown",
		"UploadLibraryDefinition":"Upload a library definition file previously downloaded",
		"UploadLibraryDefinitionNotExport":"Upload a library definition file, this is an export!",
		"ViewcodePlaceholder":"Leave empty to show actual code"
	}
});

export default labels;
